export default __webpack_public_path__ + "static/media/Pre_medical_record.dafc6e3d.svg";